import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  container: {
    maxWidth: "1300px",
    marginLeft: 0,
    padding: 0,
  },
  glossaryTitle: {
    width: 129,
    height: 36,
    fontFamily: "Inter",
    fontSize: 30,
    display: "flex",
    alignItems: "center",
    color: "#0F172A",
  },
});
